import { openHelp, useHelpAvailable } from "@/lib/help";
import type { HelpArticle } from "@/lib/help-slugs";
import { cn } from "./ui";

/** "Learn more": opens the help article. Nothing when there is no help to open. */
export function LearnMore({ article, className, children = "Learn more" }: { article: HelpArticle; className?: string; children?: string }) {
  const available = useHelpAvailable();
  if (!available) return null;
  return (
    <button
      type="button"
      onClick={() => void openHelp(article)}
      className={cn("font-medium underline", className)}
    >
      {children}
    </button>
  );
}
